import { INPUT_CLASS_NAME, STATUS } from "../constants";
import { Field, TextAreaField } from "./FormFields";

export default function ProgramDetailsFields({
  titleEn,
  setTitleEn,
  titleHi,
  setTitleHi,
  descriptionEn,
  setDescriptionEn,
  descriptionHi,
  setDescriptionHi,
  status,
  setStatus,
  setImage,
  existingImage,
}) {
  return (
    <>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <Field
          id="title_en"
          label="Title (EN)"
          value={titleEn}
          onChange={(event) => setTitleEn(event.target.value)}
          placeholder="Enter English title"
        />
        <Field
          id="title_hi"
          label="Title (HI)"
          value={titleHi}
          onChange={(event) => setTitleHi(event.target.value)}
          placeholder="Enter Hindi title"
        />
        <TextAreaField
          id="description_en"
          label="Description (EN)"
          value={descriptionEn}
          onChange={(event) => setDescriptionEn(event.target.value)}
          placeholder="Enter English description"
        />
        <TextAreaField
          id="description_hi"
          label="Description (HI)"
          value={descriptionHi}
          onChange={(event) => setDescriptionHi(event.target.value)}
          placeholder="Enter Hindi description"
        />
        <div>
          <label htmlFor="image" className="block text-sm font-semibold text-gray-900">
            Image (optional)
          </label>
          <input
            id="image"
            name="image"
            type="file"
            accept="image/*"
            onChange={(event) => setImage(event.target.files?.[0] || null)}
            className={INPUT_CLASS_NAME}
          />
          {existingImage ? (
            <img
              src={existingImage}
              alt="Current loyalty program"
              className="mt-3 h-20 w-20 rounded-lg object-cover"
            />
          ) : null}
        </div>
      </div>

      <div>
        <p className="block text-sm font-semibold text-gray-900">Status</p>
        <div className="mt-2 flex flex-wrap gap-6">
          <label htmlFor="status_active" className="inline-flex items-center gap-2 text-sm text-gray-900">
            <input
              id="status_active"
              name="status"
              type="radio"
              value={STATUS.ACTIVE}
              checked={status === STATUS.ACTIVE}
              onChange={(event) => setStatus(event.target.value)}
              className="h-4 w-4 border-gray-300 text-cyan-500 focus:ring-cyan-500"
            />
            Active
          </label>
          <label htmlFor="status_inactive" className="inline-flex items-center gap-2 text-sm text-gray-900">
            <input
              id="status_inactive"
              name="status"
              type="radio"
              value={STATUS.INACTIVE}
              checked={status === STATUS.INACTIVE}
              onChange={(event) => setStatus(event.target.value)}
              className="h-4 w-4 border-gray-300 text-cyan-500 focus:ring-cyan-500"
            />
            Inactive
          </label>
        </div>
      </div>
    </>
  );
}
